var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgSiteplanIcon = function SvgSiteplanIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24.051,
    height: 34.358,
    viewBox: "0 0 24.051 34.358",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "sitePlan",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2829",
    "data-name": "Path 2829",
    d: "M309.38,902.83q12.034-8.864,12.025-16.921a12.028,12.028,0,1,0-24.051,0Q297.355,893.948,309.38,902.83Zm0-25.769a8.567,8.567,0,0,1,8.59,8.847c0,3.711-2.955,8.023-8.59,12.575-5.635-4.553-8.59-8.882-8.59-12.575A8.567,8.567,0,0,1,309.38,877.061Z",
    transform: "translate(-297.355 -873.625)",
    fill: "#ca0928"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2830",
    "data-name": "Path 2830",
    d: "M324.759,904.465a3.436,3.436,0,1,0-3.436-3.436A3.436,3.436,0,0,0,324.759,904.465Z",
    transform: "translate(-312.733 -889.003)",
    fill: "#ca0928"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1257",
    "data-name": "Rectangle 1257",
    width: 24.051,
    height: 3.436,
    transform: "translate(0 30.923)",
    fill: "#ca0928"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSiteplanIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/siteplan-icon.00116327.svg";
export { ForwardRef as ReactComponent };